import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const ENDPOINTS = {
  "drop-list": "/admin/drop-list",
  notify: "/admin/notify",
  contraband: "/admin/contraband",
  contacts: "/admin/contacts",
};

const HEADERS = {
  "drop-list": ["Email", "Source", "Created"],
  notify: ["Email", "Product", "Created"],
  contraband: ["Email", "Product", "Acknowledged", "Created"],
  contacts: ["Name", "Email", "Subject", "Message", "Created"],
};

const TITLES = {
  "drop-list": "Drop List",
  notify: "Notify Requests",
  contraband: "Contraband Access",
  contacts: "Contacts",
};

function fmt(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}
function truncate(s, n) {
  if (!s) return "";
  return s.length > n ? s.slice(0, n) + "…" : s;
}
function row(section, r) {
  if (section === "drop-list") return [r.email, r.source || r.last_source || "-", fmt(r.created_at)];
  if (section === "notify") return [r.email, r.product_slug, fmt(r.created_at)];
  if (section === "contraband") return [r.email, r.product_slug, r.acknowledged ? "Yes" : "No", fmt(r.created_at)];
  if (section === "contacts") return [r.name, r.email, r.subject, truncate(r.message, 80), fmt(r.created_at)];
  return [];
}

export default function AdminListView({ section }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get(ENDPOINTS[section])
      .then((r) => setList(r.data))
      .finally(() => setLoading(false));
  }, [section]);

  const cols = HEADERS[section];

  return (
    <div data-testid={`admin-list-${section}`}>
      <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#ff1493]">// {TITLES[section]}</div>
      <h2 className="mt-2 font-display text-2xl md:text-4xl tracking-tight">{TITLES[section]}</h2>
      <div className="mt-6 font-mono text-[11px] tracking-[0.2em] uppercase text-[#7a6a90]">
        // {list.length} record{list.length === 1 ? "" : "s"}
      </div>
      <div className="mt-4 border border-[#2a1a3a] overflow-x-auto" data-testid={`admin-table-${section}`}>
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-[#06000e]">
              {cols.map((h) => (
                <th key={h} className="text-left font-mono text-[11px] tracking-[0.2em] uppercase text-[#ff1493] px-4 py-3 border-b border-[#2a1a3a]">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={cols.length} className="px-4 py-8 font-mono text-xs tracking-[0.2em] uppercase text-[#7a6a90]">
                  // loading...
                </td>
              </tr>
            )}
            {!loading && list.length === 0 && (
              <tr>
                <td colSpan={cols.length} className="px-4 py-8 font-mono text-xs tracking-[0.2em] uppercase text-[#7a6a90]">
                  // empty
                </td>
              </tr>
            )}
            {list.map((r) => (
              <tr key={r.id} className="border-b border-[#1a0a2a] last:border-b-0">
                {row(section, r).map((cell, i) => (
                  <td key={i} className="px-4 py-3 font-mono text-xs tracking-[0.05em] text-white align-top">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
